export const queryDate = (query, keywords) => {
  const val = query[keywords];
  if (!val) return null;
  return new Date(val);
};
